import clientSaleFullcont from "./clientSale-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const clientSaleDt = require('./clientSale-dt')
const clientSaleMenu = require('./clientSale-menu')
const handler = require('./clientSale-fullcont-handler')
const { formCopy } = require('./clientSale-fullcont-form')
const { form } = require('./clientSale-fullcont-form')
const { clientSaleMT } = require('./clientSale-fullcont-multitable')
const restriction = require('./clientSale-fullcont-restriction')
const notification = require('./clientSale-fullcont-notification')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false
var input_send_email = false
let dest = null;

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'clientSale', //database table name****
            // 'clientActivity', //dest entity on js
            dest, //dest entity on js
            'clientSale-fullcont',
            clientSaleFullcont, form, formCopy, clientSaleMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc) 
}/**/


export function start(detail) {
      //console.log('clientSale-dt 5>', detail)

      if (detail.act === "selectOne") {
            dest = "clientActivity";
      } else {
            // se resetea el "HTMLselect"
            dest = "clientSale";
            HTMLwasSelected = false
      }

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      prepareView: { start: (detail) => { fullcontHandler.prepareView(detail, htmlFc) } },
      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
      selectOne: { start: (detail) => { selectOne(detail, htmlFc) } },
      fullcontOptions: { start: (detail) => { clientSaleMenu.start(detail, 'htmlDt', htmlFc) } },
      otherFieldCustomer: { start: (detail) => { handler.otherFieldCustomer(detail, htmlFc) } },
      otherFieldItem: { start: (detail) => { handler.otherFieldItem(detail, htmlFc) } },
      shippingnow: { start: (detail) => { handler.shippingnow(htmlFc) } },
      insertshippingdatetime: { start: (detail) => { handler.insertshippingdatetime(htmlFc) } },
      showcost: { start: (detail) => { handler.showcost(htmlFc) } },
      showreturn: { start: (detail) => { handler.showreturn(htmlFc) } },
      calculatepaymentdue: { start: (detail) => { handler.calculatepaymentdue(htmlFc) } },

      pdfMenuFullcont: { start: (detail) => { pdfMenuFullcont(detail, htmlFc) } },
}/**/

export function pdfMenuFullcont(detail, htmlFc) {
      const fullcont = htmlFc.fullcontHTML ?? null;
      const dbid = fullcont.getAttribute("data-dbid") ?? detail.dbid;
      printReport(dbid, detail.entity, detail.reportName);
}

function printReport(dbid, entity, reportName) {
  const formData = new FormData();
  formData.append('id', dbid);
  formData.append('type', 'print');
  formData.append('entity', entity);
  formData.append('reportName', reportName);

  const isPdf = true;

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  fetch(`./server/php/report/report-pdf.php`, options)
  .then((response) => {
      clearTimeout(timeout);
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })

    .catch(error => {
      throw error;
    });
}

function selectOne(detail, htmlFc) {
      const entityFc = document.querySelector('#clientSale-fullcont');

      if (entityFc) {
            if (entityFc.classList.contains('fullcont-show')) {
                  entityFc.classList.remove('fullcont-show');
                  fullcontEntity.selectOne(detail, htmlFc, process_required_field_select_one)
                  return;
            }
      }

      fullcontEntity.selectOne(detail, htmlFc, process_required_field_select_one)
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'clientSale' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'clientSale', id: "deleteElem", entity: 'clientSale', dbid: detail.dbid })
}

function dtCall(act, result) {
      clientSaleDt.start({ act: act, row: result })
}

function process_required_field_select_one(data, result) {

      handler.fill_InventoryStock(data)

      let clientSale_showcost = htmlFc.fullcontHTML.querySelector('#showcost');
      clientSale_showcost.checked = false;
      let event = new Event('change');
      clientSale_showcost.dispatchEvent(event);

      let return_mt = htmlFc.fullcontHTML.querySelector('#return');
      return_mt.classList.remove('dn');

      let clientSale_showreturn = htmlFc.fullcontHTML.querySelector('#showreturn');
      clientSale_showreturn.checked = false;

      event = new Event('change');
      clientSale_showreturn.dispatchEvent(event);

}